import styled from "styled-components";

export const Adorn = styled.h3`
  font-family: 'GM-Script', 'timberline';
`;